module.exports = __webpack_public_path__ + "acfb7a4e7ea8900eca4fa81590cd1a69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/scientistavatar.svg
// module id = 36
// module chunks = 0 1